export default "__VITE_ASSET___58vvuCJ__"